import React from 'react';

import {
  Taxonomy,
} from '@uncinc/react-drupal-core';

const ViewMaterialTypes = ({ entities }) => {
  if (entities.size > 0) {
    return (
      <div className="View ViewMaterialTypes">
        <div className="row">
          {entities.map((entity) => {
            const id = entity.getIn(['tid', '0', 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            const className = 'ViewMaterialTypes__item';
            return (
              <div key={`${uuid}:${langcode}`} className="col-12">
                <div className={className}>
                  <Taxonomy
                    id={id}
                    key={`${uuid}:${langcode}`}
                    entity={entity}
                    viewMode="teaser"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default ViewMaterialTypes;
